import { Row, Col, Card } from "antd";
import "antd/dist/antd.css";
import React from "react";
import ProfileCard from "./components/ProfileCard";
import LatestTasks from "./components/LatestTasks";
import LatestEvaluations from "./components/LatestEvaluations";
import LatestReferences from "./components/LatestReferences";



const DashboardAnetar = ({ dashboardData }) => {

    return (
        <Row gutter={24}>
            <Col span={24}>
                <Row gutter={24}>
                    <Col span={24}>
                        <ProfileCard
                            dashboardData={dashboardData}
                        />
                    </Col>
                </Row>
                <Row gutter={24} className="mt-2">
                    <Col span={24}>
                        <Card>
                            <LatestTasks
                                dashboardData={dashboardData}
                            />
                        </Card>
                    </Col>
                </Row>
                <Row gutter={24} className="mt-2" style={{ display: "flex" }}>
                    <Col xl={12} lg={12} md={24} sm={24} xs={24} style={{ display: "table-cell" }}>
                        <Card style={{ height: "100%" }}>
                            <LatestEvaluations
                                dashboardData={dashboardData}
                            />
                        </Card>
                    </Col>
                    <Col xl={12} lg={12} md={24} sm={24} xs={24} style={{ display: "table-cell" }}>
                        <Card style={{ height: "100%" }}>
                            <LatestReferences
                                dashboardData={dashboardData}
                            />
                        </Card>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};


export default DashboardAnetar;